



















































import {
  DryingQualityRatingAttributeNames,
  DryingQualityRatingAttribute,
  DryingQualityRating,
} from "@/data/models/DryingQualityRating";
import { Vue, Component, Model, Prop } from "vue-property-decorator";
import { COLOR_NOT_SELECTED_QUALITY_RATING, COLOR_SELECTED_QUALITY_RATING } from "@/utils/colors";
import { themedRatingCell } from "@/utils/Theme";

@Component
export default class RateDryingQualityComponent extends Vue {
  @Prop({ default: true })
  editEnabled!: boolean;

  @Model("dryingQuality")
  dryingQualityRating!: DryingQualityRating;

  dryingQualityRatingAttributes = DryingQualityRatingAttributeNames;

  ratingOptions = ["veryBad", "bad", "good", "veryGood"];

  get headerRow() {
    return this.$t(`rateDrying.qualityDrying.title`);
  }

  getRatingFromColumnIndex(columnIndex: number) {
    //Ignore label column
    const adjustedIndex = columnIndex - 1;
    const ratingOffset = Math.floor(this.ratingOptions.length / 2);

    const isNumberOfRatingOptionsEven = (this.ratingOptions.length % 2) === 0

    if (isNumberOfRatingOptionsEven) {
      if (adjustedIndex - ratingOffset >= 0) {
        // Ignore neutral rating
        return adjustedIndex - ratingOffset + 1;
      }
    }

    return adjustedIndex - ratingOffset;
  }

  /** The cell's fill and label class for the active theme (see `themedRatingCell`). */
  ratingCell(lightColor: string) {
    return themedRatingCell(lightColor);
  }

  getRatingColor(
    columnIndex: number,
    ratingAttribute: DryingQualityRatingAttribute
  ) {
    const rating = this.getRatingFromColumnIndex(columnIndex);
    const matchesCurrentRating =
      rating === this.dryingQualityRating[ratingAttribute];

    const isNumberOfRatingOptionsEven = (this.ratingOptions.length % 2) === 0

    if (matchesCurrentRating) {
      if (rating !== 0 || isNumberOfRatingOptionsEven) {
        return COLOR_SELECTED_QUALITY_RATING;
      }
      else {
        return COLOR_NOT_SELECTED_QUALITY_RATING;
      }
    } else {
      return COLOR_NOT_SELECTED_QUALITY_RATING;
    }
  }

  toggleDryingQualityRating(
    columnIndex: number,
    ratingAttribute: DryingQualityRatingAttribute
  ) {
    const currentRating = this.dryingQualityRating[ratingAttribute];
    const newRating = this.getRatingFromColumnIndex(columnIndex);

    const update = {
      ...this.dryingQualityRating,
      [ratingAttribute]:
        currentRating === newRating
          ? null
          : this.getRatingFromColumnIndex(columnIndex),
    };

    this.$emit("dryingQuality", update);
  }

  getDryingQualityRow(rating: DryingQualityRatingAttribute) {
    return [
      this.$t(`rateDrying.qualityDrying.${rating}`),
      ...this.ratingOptions.map((res) =>
        this.$t(`rateDrying.qualityDrying.${res}`)
      ),
    ];
  }

  canCellBeClicked(index: number) {
    return index > 0;
  }
}
